// import "../css/style.css";
import icespice from "../css/img/icespice-logo.png";
import check from "../css/img/check.png";
import { Helmet, HelmetProvider } from "react-helmet-async";
import {
  Link,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { useEffect } from "react";
import ReactGA from "react-ga4";

function PopUp() {
  // let {session_token} = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  let session_token = searchParams.get("session_token");
  const nav = useNavigate();
  // console.log(session_token)
  // console.log(window)
  // if (window.location.host ==="localhost:3000") {
  //   console.log("enter")
  //   window._env_ = {
  //     REACT_APP_LIVE_API_URL: "https://staging.icespice.com",
  //   }
  // } else {
  //   window._env_ = {
  //     REACT_APP_LIVE_API_URL: "https://icespiceapi.betheforce.in",
  //   }
  // }
  if (!session_token || session_token === localStorage.getItem("sessionId")) {
    // console.log("restored")
    session_token = localStorage.getItem("sessionId");
    // ReactGA.event({
    //   category: "SessionToken",
    //   action: "Session login",
    //   label: "token", // Or any other relevant label
    //   value: session_token,
    // });
  } else {
    // console.log(session_token)
    localStorage.clear();
    localStorage.setItem("sessionId", session_token);
  }
  useEffect(() => {
    // localStorage.setItem("token","")
    // setTimeout(() => {
    //   // alert("flsk")
    //     return nav(`/s/${session_token}`,{ replace: true });
    // }, 3000);
    // setTimeout(() => {
    //   return nav(`/s/${session_token}`, { replace: true });
    // }, 2000);
    return nav(`/s/${session_token}`, { replace: true });
  }, []);
  return (
    <>
      <HelmetProvider>
        <Helmet>
          <title>Congratulations</title>
        </Helmet>
      </HelmetProvider>

      <div className="container">
        <main className="popup-main">
          <div className="circleblurbg"></div>
          <div className="circleblur1" />
          <img src="/assets/images/icespice-logo.png" alt="IceSpice Logo" />
          <h4 className="mt-4">
            <div className="line">Hey!!! Welcome to IceSpice.</div> <br />
            <div className="line">
              Play the game, earn SpiceGold and use SpiceGold to get discounts
              on some cool stuff!{" "}
            </div>
            <div className="line">Sign Up and Get Discounted Goodies</div>
          </h4>
          <Link to={`/s/${session_token}`}>
            <button className="btn btn-icespice">Enter our world</button>
          </Link>
        </main>
      </div>
    </>
  );
}

export default PopUp;
